import React from 'react';
import useAuth from '../hooks/useAuth';
import Header from './Header';
import ReactDragAndDropFile from './ReactDragAndDropFile';

const ListUpload = () => {

    const { fileUploadError } = useAuth()

    return (
        <div className='bg-brand'>
            <div className="container">
                <Header />

                <div className="bg-white-container mx-auto d-block">
                    <h2 className='fs-5 text-center pt-3 fw-bold'>Upload your document here</h2>

                    {
                        fileUploadError && <p className="text-center fw-bold text-danger">{fileUploadError}</p>
                    }

                    <div className="upload-documents-container mx-auto d-block mt-3 py-4">
                        <ReactDragAndDropFile />
                    </div>
                </div>

            </div>
        </div>
    );
};

export default ListUpload;